/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'CategoryLines': {
    width: 10,
    height: 8,
    viewBox: '0 0 10 8',
    data: '<path pid="0" d="M.55 5.156h9.1V4.145H.55v1.01zm0 2.022h9.1V6.167H.55v1.01zm0-4.045h9.1v-1.01H.55v1.01zM.55.1v1.011h9.1V.101H.55z" _fill="#fff"/>'
  }
})
